import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createTheme } from '@mui/material/styles';
export var generateUniversalMuiTheme = function generateUniversalMuiTheme(customTheme, config) {
  return createTheme({
    palette: _objectSpread({
      primary: {
        main: '#0E35D1'
      }
    }, customTheme === null || customTheme === void 0 ? void 0 : customTheme.palette),
    typography: _objectSpread({
      fontFamily: 'Raleway,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
      body2: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '18px'
      }
    }, customTheme === null || customTheme === void 0 ? void 0 : customTheme.typography),
    components: _objectSpread({
      MuiButton: {
        styleOverrides: {
          root: {
            letterSpacing: 0,
            textTransform: 'none'
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            fontWeight: 700,
            color: '#202020',
            textTransform: 'none'
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& input': {
              boxShadow: 'none!important'
            }
          }
        }
      }
    }, customTheme === null || customTheme === void 0 ? void 0 : customTheme.components)
  });
};